import axios from 'axios';
import { createBrowserHistory } from 'history';
import {
  CUSTOMER_KEY,
  getCurrentUserBySessionKey,
  updateCurrentCustomer,
} from '../../utils/authenticated-user';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_SERVER_URL || 'http://localhost:8080',
  timeout: Number(process.env.REACT_APP_API_TIMEOUT),
});

api.interceptors.request.use(
  function (config) {
    document.body.classList.add('loading-indicator');
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => {
    document.body.classList.remove('loading-indicator');
    return response;
  },
  async (error) => {
    document.body.classList.remove('loading-indicator');
    if (![403, 401].includes(error?.response?.status)) {
      return Promise.reject(error);
    }
    const customer = getCurrentUserBySessionKey(CUSTOMER_KEY);
    if (!customer) return Promise.reject(error);

    try {
      const { data } = await postRefreshToken(customer.refreshToken);
      updateCurrentCustomer({ ...customer, token: data });
    } catch (error) {
      handleSessionExpiration();
    }

    return Promise.reject(error);
  },
);

function handleSessionExpiration() {
  createBrowserHistory().push('/');
  sessionStorage.removeItem('customer');
}

const postRefreshToken = (refreshToken: string) => {
  return api.post('/refreshtoken', {
    refreshToken,
  });
};

api.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
api.defaults.headers.get['Access-Control-Allow-Origin'] = '*';

export default api;
